import { getDimensions, getMetrics, getCompare, getReportConfig, getFrequency } from 'reporting-data/report/configReportGetters';
import { isUnifiedEventsReport } from 'reporting-data/tsTypes/reportTypes';
import { toMetricKey } from 'reporting-data/v2/dataset/datasetMetrics';
import { getReportColorEncoding, getReportValuesEncodings, getReportXEncoding, getReportYEncoding, getReportSingleValueEncoding, getReportCompareEncoding, getReportOptions, getDateResolution } from 'reporting-snowflake/relational/utils/report-utils';
import { SUM } from 'reporting-data/constants/metricTypes';
import { isList } from 'reporting-snowflake/shared/lib/utility-types';
/**
 * Infer column details from config report.
 */
export const getConfigReportDetails = configReport => {
  const dimensions = getDimensions(configReport).toArray();
  const configReportObj = getReportConfig(configReport);
  const frequency = getFrequency(configReportObj);
  const compare = getCompare(configReportObj);
  const metrics = getMetrics(configReport).map(metric => {
    if (isUnifiedEventsReport(configReport)) {
      return metric.get('property');
    }
    const type = metric.getIn(['metricTypes']);
    return toMetricKey({
      property: metric.get('property'),
      type: type ? type.get(0) : SUM
    });
  }).toArray();
  return {
    dimensions,
    metrics,
    compare,
    frequency
  };
};

/**
 * Infer column details from relational report.
 *
 * Note that the relational report has different channels for different visualization types.
 * This method extracts all channel information that can be used to build a visualization specific layer.
 */
export const getRelationalReportDetails = reportDefinition => {
  var _singleValueObj$colum, _compare$column;
  const x = getReportXEncoding(reportDefinition);
  const dimensions = x && x.get('column').alias ? [x.column.alias] : undefined;
  const y = getReportYEncoding(reportDefinition);
  const metrics = y && y.column.alias ? [y.column.alias] : undefined;
  const color = getReportColorEncoding(reportDefinition);
  const breakdown = color && color.column.alias;
  const frequency = getDateResolution(breakdown, reportDefinition);
  const values = getReportValuesEncodings(reportDefinition);
  const valueFields = isList(values) ? values.map(value => value.column.alias).toArray() : undefined;

  // in the case of gauge charType, we use singleValue as the metrics
  const singleValueObj = getReportSingleValueEncoding(reportDefinition);
  const singleValue = !isList(singleValueObj) && singleValueObj !== null && singleValueObj !== void 0 && (_singleValueObj$colum = singleValueObj.column) !== null && _singleValueObj$colum !== void 0 && _singleValueObj$colum.alias ? [singleValueObj.column.alias] : undefined;
  const compare = getReportCompareEncoding(reportDefinition);
  const compareField = !isList(compare) ? compare === null || compare === void 0 || (_compare$column = compare.column) === null || _compare$column === void 0 ? void 0 : _compare$column.alias : undefined;
  const options = getReportOptions(reportDefinition);
  return {
    dimensions,
    // we consider y, values, and singleValue as metrics
    // at any given time, only one of them will be present
    metrics: metrics || valueFields || singleValue,
    breakdown,
    compareField,
    options,
    frequency
  };
};